import { useQuery } from '@tanstack/react-query';
import {
  listPermissionRequests,
} from '@/api/permissionRequests';

import {
  fetchAccessibleAgents, fetchAccessibleFeatures, fetchRequestableModels, fetchRequestableAgents, fetchRequestableFeatures,
  modelsAPI
} from '@/api/models'
import { queryKeys } from '@/lib/queryKeys';

export function usePermissionRequestsQuery(
  status?: 'pending' | 'approved' | 'denied' | 'cancelled',
  groupByUser: boolean = false,
  enabled: boolean = true
) {
  return useQuery({
    queryKey: queryKeys.permissionRequests.list(status, groupByUser ? 'user' : undefined),
    queryFn: () => listPermissionRequests(status, groupByUser ? 'user' : undefined),
    enabled,
  });
}

export function useAccessiblePermissionsQuery(enabled: boolean = true) {
  return useQuery({
    queryKey: queryKeys.permissionRequests.accessible(),
    queryFn: async () => {
      const [models, agents, features] = await Promise.all([
        modelsAPI.getAccessibleModels(),
        fetchAccessibleAgents(),
        fetchAccessibleFeatures(),
      ]);
      return { models, agents, features };
    },
    enabled,
    staleTime: 10 * 60 * 1000, // 10 minutes
  });
}

export function useRequestablePermissionsQuery(enabled: boolean = true) {
  return useQuery({
    queryKey: queryKeys.permissionRequests.requestable(),
    queryFn: async () => {
      const [models, agents, features] = await Promise.all([
        fetchRequestableModels(),
        fetchRequestableAgents(),
        fetchRequestableFeatures(),
      ]);
      return { models, agents, features };
    },
    enabled,
    staleTime: 10 * 60 * 1000, // 10 minutes
  });
}
